// src/components/Footer.tsx
import React from 'react';
import { Layout } from 'antd';

const { Footer: AntFooter } = Layout;

/**
 * Simple footer displayed at the bottom of the page.
 * The version is read from the package.json at build time via Vite's import.meta.
 */
const Footer: React.FC = () => {
  // Vite injects the version from package.json when using import.meta.env.
  const version = import.meta.env?.VITE_APP_VERSION || '0.0.0';
  const year = new Date().getFullYear();
  return (
    <AntFooter style={{ textAlign: 'center' }}>
      Pivot © {year} – Version {version}
    </AntFooter>
  );
};

export default Footer;
